/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../../utility/Constant";

const VisaPage = () => {
  const { visaApi } = apiPath;
  const { clientVisa } = clientSideUrl;
  const [visaData, visaLoading] = useFetch(visaApi);

  if (visaLoading) {
    return <Loading />;
  }

  const {
    banner_img,
    banner_title,
    banner_subtitle,
    banner_description,
    visa_processing,
    legal_services,
    mid_para_title,
    visa_title,
    service_list,
    para_description,
    para_title,
    _id,
  } = visaData[0];

  const bannerData = [
    {
      elementType: "input",
      label: "Banner title",
      type: "Text",
      name: "banner_title",
      defaultValue: banner_title,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner subtitle",
      type: "Text",
      name: "banner_subtitle",
      defaultValue: banner_subtitle,
      required: false,
    },
    {
      elementType: "textField",
      label: "Banner description",
      type: "Text",
      name: "banner_description",
      defaultValue: banner_description,
      required: false,
    },
  ];

  const data = [
    {
      elementType: "textField",
      label: "visa processing",
      type: "Text",
      name: "visa_processing",
      defaultValue: visa_processing,
      required: false,
    },
    {
      elementType: "textField",
      label: "legal services",
      type: "Text",
      name: "legal_services",
      defaultValue: legal_services,
      required: false,
    },
    {
      elementType: "input",
      label: "mid para title",
      type: "Text",
      name: "mid_para_title",
      defaultValue: mid_para_title,
      required: false,
    },
    {
      elementType: "input",
      label: "visa title",
      type: "Text",
      name: "visa_title",
      defaultValue: visa_title,
      required: false,
    },
    {
      elementType: "richTextEditor",
      label: "service list",
      type: "Text",
      name: "service_list",
      defaultValue: service_list,
      required: false,
    },
    {
      elementType: "textField",
      label: "para description",
      type: "Text",
      name: "para_description",
      defaultValue: para_description,
      required: false,
    },
    {
      elementType: "input",
      label: "testing process",
      type: "Text",
      name: "para_title",
      defaultValue: para_title,
      required: false,
    },
    {
      elementType: "file",
      label: `Banner Image`,
      name: "banner_img",
      type: "file",
      fullCol: true,
      defaultValue: banner_img,
      required: false,
    },
  ];

  const update = (data) => {
    const { banner_img, ...rest } = data;
    if (banner_img) {
      rest.banner_img = {
        url: banner_img,
      };
    }
    updateData(visaApi, rest, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientVisa}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>

      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        <h1 className="md:ml-8 font-bold text-2xl mt-4  uppercase">
          banner content
        </h1>

        <GlobalForm data={bannerData} update={update} />
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        <h1 className="md:ml-8 font-bold text-2xl mt-4  uppercase">
          section info
        </h1>
        <GlobalForm data={data} update={update} />
      </div>
    </div>
  );
};

export default VisaPage;
